import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CoursesService } from 'src/app/Services/Courses.service';
import * as Player from "@vimeo/player/dist/player.js";
import { DomSanitizer } from '@angular/platform-browser';
declare var $;

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  @ViewChild('closeModal', {static: false}) closeModal: ElementRef<HTMLInputElement>;

  submitted = false;
  sendingStatus = {
    loading: false,
    message: null,
    error: false,
    submitted: false,
  }
  videoId = '415513542';
  videoLoaded = false;
  isVideoShown = false;
  videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + this.videoId)

  faqs = [
    {
      title: 'Se o curso é online, como ele é personalizado?',
      content: 'Quando começar o seu plano, você irá responder uma entrevista onde vai nos contar sobre seu perfil e objetivos. Nossa tecnologia irá analisar suas respostas e montar um plano de curso 100% personalizado ao seu perfil, te direcionando automaticamente para as aulas que vão te ajudar a chegar ao seu objetivo, de acordo com suas habilidades e preferências.',
      collapsed: false,
    },
    {
      title: ' As aulas são gravadas ou “ao vivo” pelo Skype?',
      content: 'Todas as aulas são em formato de vídeo gravadas em Full HD e qualidade de áudio de ponta. A personalização acontece com o direcionamento de aulas específicas para cada aluno, e não com aulas particulares via Skype. Você tem acesso a todas as aulas 24 horas por dia, para estudar de acordo com sua disponibilidade e disposição.',
      collapsed: false,

    },
    {
      title: 'Como terei contato com o professor?',
      content: 'Dentro da plataforma você terá acesso a um chat para tirar dúvidas diretamente com o seu professor. Envie sua mensagem e, em até 72 horas, o seu professor irá te responder!',
      collapsed: false,
    },
    {
      title:  'Qual a duração dos cursos? Posso baixar o material?',
      content: 'Você pode escolher entre planos de 1, 6 ou 12 meses de acesso à plataforma, com todas as aulas e funcionalidades. Você, também, pode fazer download de todo o material de apoio em PDF e Mp3 de cada aula.',
      collapsed: false,
    },
    {
      title: 'Os cursos são para qual nível?',
      content: 'A LUMI é feita para todos os níveis! Depois de analisarmos sua entrevista, iremos lhe mandar aulas que estão de acordo com sua realidade. Temos em nossa base de dados aulas gravadas para conteúdos básicos, intermediários e avançados.',
      collapsed: false,
    },
  ];

  constructor(private coursesService: CoursesService, public sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  setAllClosed(title) {
    this.faqs = this.faqs.map((faq) => {
      return {...faq, collapsed: faq.title == title}
    });
  }


  initializeVideoPlayer(videoId) {
    this.videoId = videoId;
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + this.videoId)
    $("#modal-faq").on("hide.bs.modal", () => {
      this.videoId = null;
      this.videoUrl = null;
      try {
        document.getElementById('videoFrame').remove()
      } catch (error) {

      }

    });

  }

  openVideoModal(videoId) {
    this.videoId = videoId;
    setTimeout(() => {
      this.isVideoShown = false;
      this.videoLoaded = true;
      this.initializeVideoPlayer(videoId)
    }, 200);
  }

  onSubmit(contactForm: NgForm) {
    this.sendingStatus.submitted = true;
    this.sendingStatus.message = null;
    if(contactForm.invalid) {
      return
    }
    this.sendingStatus.loading = true;
    this.coursesService.sendContactForm(contactForm.value).then(() => {
      this.sendingStatus.loading = false;
      this.sendingStatus.message = 'Mensagem enviada! Em breve nós respondemos, ok?';
      this.sendingStatus.error = false;
      this.sendingStatus.submitted = false;

      contactForm.resetForm();
    }).catch((error) => {
      this.sendingStatus.loading = false;
      this.sendingStatus.error = true;
      this.sendingStatus.message = 'Error sending message. Please try again later';
      this.sendingStatus.submitted = false;
    })


  }

  showError(form: NgForm, fieldName) {
    if(!this.sendingStatus.submitted) {
      return false;
    }
    return form.control.get(fieldName) && !form.control.get(fieldName).valid
  }

  showVideo() {
    return this.videoId && this.videoUrl;
  }

}
